module.exports = __webpack_public_path__ + "img/Zusatzwissen_B.f9e4dff2.png";